// extracted by mini-css-extract-plugin
module.exports = {"price":"_8525","value":"_12656","ios":"_15783"};